var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation-menu-button',{attrs:{"is-open":_vm.isMenuOpen},on:{"click":function($event){_vm.isMenuOpen = !_vm.isMenuOpen}}}),_vm._v(" "),_c('div',{class:[
            `
                fixed
                lg:relative
                top-0
                left-0
                flex
                flex-1
                flex-col
                justify-center
                lg:flex-row
                lg:w-auto
                lg:flex-0
                lg:items-center
                w-full
                min-h-screen
                lg:min-h-0
                pt-6
                lg:p-0
                overflow-y-auto
                lg:overflow-visible
                pointer-events-none
                lg:pointer-events-auto
                navigation
            `,
            {
                open: _vm.isMenuOpen,
            },
        ]},[_c('div',{ref:"navigationContent",staticClass:"relative z-50 w-full opacity-0 lg:opacity-100 navigation-content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{ref:"navigationBg",staticClass:"fixed top-0 right-0 lg:hidden w-full h-0 bg-secondary"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }